import React from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Button,
  TextField,
} from '@material-ui/core';

import Loading from '@common/components/Loading';

import Api from '../api';
import LoginTrugreenIssuesModal from './LoginTrugreenIssuesModal';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      showModal: false,
    };
  }

  componentDidMount() {
    const { userStore } = this.props;

    userStore.fetchUserProfile().then(() => {
      this.setState({ isLoading: false });
    });
  }

  renderLoading = () => (
    <Loading />
  );

  handleLogin = async () => {
    try {
      const { email } = this.state;
      const { userStore } = this.props;
      const response = await Api.getLoginMechanismTrugreen(email.trim());

      if (!response || response.status !== 200) {
        alert('Double-check your credentials and please try again. If the issue continues, contact support.');
      }

      if (response.data.next) {
        window.location.href = response.data.next;
      } else if (response.data) {
        userStore.fetchUserProfile();
      }
    } catch (e) {
      // alert('Your username is not found.');
    }
  };

  handleModal = () => {
    this.setState((prev) => ({ showModal: !prev.showModal }));
  }

  keyPress(e) {
    if (e.keyCode === 13) {
      this.handleLogin();
    }
  }

  renderLoginButtons = () => {
    const { userStore, classes } = this.props;
    const { isLoading, showModal } = this.state;

    if (userStore.ssoUrl || isLoading) {
      return this.renderLoading();
    }

    return (
      <div className={classes.container}>
        <Grid container className={classes.header}>
          <img
            alt="logo"
            className={classes.logo}
            src="10.webp"
          />
        </Grid>
        <Grid
          container
          justify="center"
          alignContent="center"
          alignItems="center"
          direction="column"
          className={classes.loginContainerWrapper}
        >
          <Grid
            container
            item
            direction="column"
            justify="center"
            alignContent="center"
            spacing={4}
            className={classes.loginContainer}
          >
            <Grid item className={classes.textFieldContainer}>
              <TextField
                className={classes.loginTextContainer}
                fullWidth
                onKeyDown={this.keyPress.bind(this)}
                onChange={(e) => this.setState({ email: e.target.value })}
                id="outlined-password-input"
                placeholder="Enter your Employee ID"
                                // label="Enter your email address to login"
                autoComplete="current-password"
                inputProps={{
                  style: {
                    textAlign: 'center',
                    fontFamily: "'Public Sans',sans-serif",
                    fontSize: '18px',
                  },
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item className={classes.loginButtonContainer}>
              <Button
                className={classes.loginButton}
                type="submit"
                onClick={this.handleLogin.bind(this)}
              >
                Login
              </Button>
            </Grid>
          </Grid>
          <Grid item>
            <button
              className={classes.link}
              onClick={this.handleModal}
            >
              Trouble logging in?
            </button>
          </Grid>
        </Grid>
        {showModal && (
          <LoginTrugreenIssuesModal
            open={showModal}
            handleCloseModal={this.handleModal}
          />
        )}
      </div>
    );
  };

  renderLogin = () => {
    const { userStore } = this.props;

    return userStore.isAuthenticated ?
      <Redirect to="/" /> :
      this.renderLoginButtons();
  };

  render() {
    return this.renderLogin();
  }
}

const styles = (theme) => ({
  container: {
    height: '100vh',
    background: 'url(9.png)',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    overflow: 'hidden',
  },
  loginContainerWrapper: {
    height: '100%',
  },
  logo: {
    width: 305,
    marginTop: '70px',
    [theme.breakpoints.down('sm')]: {
      width: 260,
    },
  },
  loginContainer: {
    width: 400,
    flex: 1,
  },
  loginTextContainer: {
    background: 'white',
    width: '100%',
    textAlign: 'center',
    borderRadius: '7px',
  },
  textFieldContainer: {
    width: '540px',
    padding: '10px !important',
    [theme.breakpoints.down('md')]: {
      width: '460px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '360px',
    },
  },
  loginButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px !important',

  },
  loginButton: {
    height: '40px',
    width: '128px',
    background: 'transparent',
    textTransform: 'none',
    padding: '12px 10px 14px 10px',
    color: 'white',
    fontWeight: 'bold',
    '&:hover': {
      background: 'transparent',
      border: '1px solid white',
      opacity: '0.5',
    },
    fontSize: '24px',
    fontFamily: "'Public Sans',sans-serif",
  },
  header: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100px',
    position: 'fixed',
    top: '0',
  },
  link: {
    padding: '0',
    font: 'inherit',
    fontSize: '1rem',
    backgroundColor: 'transparent',
    border: 'none',
    color: 'white',
    textDecoration: 'none',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
    marginBottom: '5rem',
    [theme.breakpoints.down('md')]: {
      marginBottom: '3rem',
    },
  },
});

Login.propTypes = {
  classes: PropTypes.shape({
    container: PropTypes.string.isRequired,
    loginContainerWrapper: PropTypes.string.isRequired,
    logo: PropTypes.string.isRequired,
    loginContainer: PropTypes.string.isRequired,
    loginTextContainer: PropTypes.string.isRequired,
    textFieldContainer: PropTypes.string.isRequired,
    loginButtonContainer: PropTypes.string.isRequired,
    loginButton: PropTypes.string.isRequired,
    header: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  }).isRequired,
  userStore: PropTypes.shape({
    isAuthenticated: PropTypes.bool.isRequired,
    ssoUrl: PropTypes.string,
    fetchUserProfile: PropTypes.func.isRequired,
  }).isRequired,
};
export default withStyles(styles)(inject('userStore')(observer(Login)));
